module.exports = __webpack_public_path__ + "static/media/completo-negro.3efd8f12.png";